/**
 * Module contains a function for creating a state object
 * used for building legends and storing hover and open or closed state.
 */

import Vue from 'vue';

/**
 * returns an of objects containing the text for the drop downs on
 * the compairson view and the quarter's location in the riskData for
 * look up.
 * @param {object} riskData object containing riskdata for the release.
 */
function buildQuarterList(riskData) {
  let i;
  let j;
  let year;
  let quarter;
  let count = 0;
  const quarters = [];
  for (i = riskData.length - 1; i > -1; i -= 1) {
    year = riskData[i];
    for (j = year.quarters.length - 1; j > -1; j -= 1) {
      quarter = year.quarters[j];
      quarters.push({
        name: `${quarter.quarter} ${year.year}`,
        value: count,
        yearIndex: i,
        quarterIndex: j,
      });
      count += 1;
    }
  }
  return quarters;
}

function isQuarterComplete(riskData, quarter) {
  const quarterData = riskData[quarter.yearIndex].quarters[quarter.quarterIndex].categories;
  let count = 0;
  for (let i = 0; i < quarterData.length; i += 1) {
    if (quarterData[i].score) {
      count += 1;
    }
  }
  return count > 0;
}

/**
 * Checks to see if most recent quarter is complete. If not, sets the initial quarters back one.
 * @param {array} riskData
 * @param {array} quarterList
 */
function setInitialQuarters(riskData, quarterList) {
  let currentA;
  let currentB;
  if (isQuarterComplete(riskData, quarterList[0])) {
    currentA = quarterList[4];
    currentB = quarterList[0];
  } else {
    currentA = quarterList[5];
    currentB = quarterList[1];
  }
  return { currentA, currentB };
}


export default function (riskData) {
  let i;
  let j;
  let k;
  let category;
  let categoryObj;
  let subcategory;
  let subcategoryObj;
  let indicator;
  let indicatorObj;

  const categories = riskData[0].quarters[0].categories;

  // Set initial view of the long-term view time block
  const end = window.innerWidth > 1200 ? 7 : 6;
  const start = riskData.length - end;
  const timeBlock = {
    end,
    start,
    // upper limit to prevent users from advancing too far.
    maxStart: start,
  };

  const catArray = [];

  for (i = 0; i < categories.length; i += 1) {
    category = categories[i];
    categoryObj = {
      name: category.name,
      subcategories: [],
    };

    for (j = 0; j < category.subcategories.length; j += 1) {
      subcategory = category.subcategories[j];
      subcategoryObj = {
        name: subcategory.name,
        indicators: [],
      };
      this.$set(subcategoryObj, 'showCurrentIndicators', false);
      // this.$set(subcategoryObj, 'showHistoricalIndicators', false);
      // this.$set(subcategoryObj, 'showVintageIndicators', false);
      for (k = 0; k < subcategory.indicators.length; k += 1) {
        indicator = subcategory.indicators[k];
        indicatorObj = {
          name: indicator.name,
        };
        this.$set(indicatorObj, 'indicatorHovered', false);
        subcategoryObj.indicators.push(indicatorObj);
      } // end indicators for loop
      categoryObj.subcategories.push(subcategoryObj);
    } // end subcategories for loop
    catArray.push(categoryObj);
  } // end categories for loop
  const state = { categories: catArray, quarters: buildQuarterList(riskData), timeBlock };
  Object.assign(state, setInitialQuarters(riskData, state.quarters));

  return state;
}



// WEBPACK FOOTER //
// ./src/helpers/storeHelpers.js